module.exports = __webpack_public_path__ + "media/images/icons/menu_catalogs-38deda1892b58a526990b176586de851.svg";